import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { SharedModule } from '../shared/shared.module';
import { LayoutComponent } from './layout.component';
import { MainContentComponent } from './main-content/main-content.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { UrlListSidebarComponent } from './url-list-sidebar/url-list-sidebar.component';
import { UrlListComponent } from './url-list/url-list.component';
import { StartPageComponent } from '@fb-tool-front/start-page/start-page.component';
import { AppThemeNightComponent } from '@fb-tool-front/theme-night/theme-night.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    ToolbarComponent,
    MainContentComponent,
    LayoutComponent,
    ErrorPageComponent,
    StartPageComponent,
    UrlListComponent,
    UrlListSidebarComponent,
    AppThemeNightComponent
  ],
  exports: [LayoutComponent]
})
export class LayoutModule {}
